// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"154":"69fb80ab","336":"f2945438"}[chunkId] + ".chunk.js";
};